/// <reference path="../Bases/GridBase.ts" />
namespace _Ext {
    import fld = TabAurous.Purchase.PurchaseItemsBOMRow.Fields;
    @Serenity.Decorators.registerClass([Serenity.IGetEditValue, Serenity.ISetEditValue, Serenity.IReadOnly])
    @Serenity.Decorators.editor()
    @Serenity.Decorators.element("<div/>")
    export class BOMGridEditor<TEntity> extends _Ext.GridBase<TEntity, any>
        implements Serenity.IGetEditValue, Serenity.ISetEditValue, Serenity.IReadOnly {
        protected getColumnsKey() { return "Common.CommonBOMColumns"; }

        protected form: TabAurous.Common.CommonBOMForm;
        protected get_ExtGridOptions(): ExtGridOptions { return Q.deepClone(q.DefaultEditorGridOptions); }
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public MarkUpPolicyId: number;
        public TransDate: Date;
        public coef: number;
        protected getIdProperty() { return "__id"; }
        public pendingChanges: Q.Dictionary<any> = {};

        isChildGrid = true;

        protected nextId = 1;

        constructor(container: JQuery) {
            super(container);

            this.slickGrid.onSort.subscribe((e, args) => {
                this.sortGridFunction((args.grid as Slick.Grid), args.sortCols[0], args.sortCols[0].sortCol.field);

                //(args.grid as Slick.Grid).init();
                (args.grid as Slick.Grid).invalidateAllRows();
                (args.grid as Slick.Grid).invalidate();
                (args.grid as Slick.Grid).render();
                (args.grid as Slick.Grid).resizeCanvas();
            });

        }

        private sortGridFunction(grid: Slick.Grid, column: any, field: any) {
            grid.getData().sort(function (a, b) {
                var result = a[field] > b[field] ? 1 :
                    a[field] < b[field] ? -1 :
                        0;
                return column.sortAsc ? result : -result;
            });
        }

        protected getQuickFilters() {
            return [];
        }

        protected id(entity: TEntity) {
            return (entity as any)[this.getIdProperty()];
        }

        protected save(opt: Serenity.ServiceOptions<any>, callback: (r: Serenity.ServiceResponse) => void) {
            var request = opt.request as Serenity.SaveRequest<TEntity>;
            var row = Q.deepClone(request.Entity);

            var id = this.id(row);
            if (id == null) {
                row[this.getIdProperty()] = "`" + this.nextId++;
            }

            if (!this.validateEntity(row, id)) {
                return;
            }

            var items = this.view.getItems().slice();
            if (id == null) {
                items.push(row);
            }
            else {
                var index = Q.indexOf(items, x => this.id(x) === id);
                items[index] = Q.deepClone({} as TEntity, items[index], row);
            }

            this.value = items;
            callback({});
        }

        protected deleteEntity(id: number) {
            this.view.deleteItem(id);
            setTimeout(() => {
                this.onItemsChanged();
                this.element.trigger('change');
                this.resetRowNumber();
            });
            return true;
        }

        protected validateEntity(row: TEntity, id: number) {
            return true;
        }

        protected getNewEntity(): TEntity {
            return {} as TEntity;
        }

        protected getButtons(): Serenity.ToolButton[] {
            return [{
                title: this.getItemName(),
                cssClass: 'add-button',
                onClick: () => { this.addButtonClick() }
            }, Serenity.ColumnPickerDialog.createToolButton(this as any)];
        }

        protected addButtonClick(): void {
            this.createEntityDialog(this.getItemType(), dlg => {
                var dialog = dlg as BOMEditorDialog<TEntity>;
                dialog.parentEditor = this;
                this.setMasterValues();
                dialog.onSave = (opt, callback) => this.save(opt, callback);
                dialog.loadEntityAndOpenDialog(this.getNewEntity());
            });
        }

        protected editItem(entityOrId: any): void {

            var id = entityOrId;
            var item = this.view.getItemById(id);
            this.createEntityDialog(this.getItemType(), dlg => {
                var dialog = dlg as BOMEditorDialog<TEntity>;
                dialog.onDelete = (opt, callback) => {
                    if (!this.deleteEntity(id)) {
                        return;
                    }
                    callback({});
                };
                dialog.parentEditor = this;
                dialog.onSave = (opt, callback) => this.save(opt, callback);
                dialog.loadEntityAndOpenDialog(item);
            });;
        }

        public getEditValue(property, target) {
            target[property.name] = this.value;
        }

        public setEditValue(source, property) {
            this.value = source[property.name];
        }

        public get value(): TEntity[] {
            var p = this.getIdProperty();

            (this.slickGrid as any).getEditController().commitCurrentEdit();

            let items = this.view.getItems();

            this.onBeforeGetValue(items);

            return items.map(x => {
                var y = Q.deepClone(x);
                var id = y[p];
                if (id && id.toString().charAt(0) == '`')
                    delete y[p];

                if (y['RowNum'])
                    delete y['RowNum'];
                return y;
            });
        }

        public set value(value: TEntity[]) {
            var id = this.getIdProperty();

            let val = value || [];

            let items = val.map(x => {
                var y = Q.deepClone(x);
                if ((y as any)[id] == null) {
                    (y as any)[id] = "`" + this.nextId++;
                }
                return y;
            });

            let r = this.onViewProcessData({ Entities: items })
            this.view.setItems(r.Entities, true);
            setTimeout(() => {
                this.onItemsChanged();
                this.element.trigger('change');
            });
            this.resetRowNumber(); // to generate serial no.
        }

        protected getGridCanLoad() {
            return false;
        }

        protected usePager() {
            return false;
        }

        protected getInitialTitle() {
            return null;
        }

        private searchText: string;

        protected createToolbarExtensions(): void {
            //super.createToolbarExtensions();
            if (this.get_ExtGridOptions().EnableQuickSearch) {
                Serenity.GridUtils.addQuickSearchInputCustom(this.toolbar.element, (field, text) => {
                    this.searchText = Select2.util.stripDiacritics(Q.trimToNull(text) || '').toLowerCase();
                    this.view.setItems(this.view.getItems(), true);
                });
            }
        }

        protected onViewFilter(row): boolean {
            if (!super.onViewFilter(row)) {
                return false;
            }

            if (this.searchText) {
                return this.matchContains(row);
            }

            return true;
        }

        private matchContains(item): boolean {
            let result = false;

            for (let prop in item) {
                result = Select2.util.stripDiacritics(String(item[prop] || '')).toLowerCase().indexOf(this.searchText) >= 0;

                if (result == true) {
                    return result;
                }
            }

            return result;
        }
         
        protected enableFiltering(): boolean { return false; }

        protected onViewSubmit() { return false; }

        get_readOnly(): boolean {
            return this.isReadOnly;
        }
        set_readOnly(value: boolean): void {
            this.isReadOnly = value;
            if (value == true) {
                this.element.find('.add-button').addClass('disabled');
                let opt = this.slickGrid.getOptions();
                opt.editable = false;

                this.slickGrid.setOptions(opt);
            } else {
                this.element.find('.add-button').removeClass('disabled');
            }

        }
        // **** to Call shortcut key in Main Window
        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.forceFitColumns = false;
            //opt.autoHeight = true; // If you need to show footer, you have to do opt.autoHeight = false
            return opt;
        }

        parentDialog: ItemDialog<any, any>;

        //custom events
        onItemsChanged() {

        }
        onBeforeGetValue(items: TEntity[]) {

        }
        protected getColumns() {

            var columns = super.getColumns();
            var amt = ctx => this.isReadOnly ? TabAurous.ColumnFormatter.ReadOnlyAmountFormatter(ctx, this) : TabAurous.ColumnFormatter.AmountFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.BomRate).format = amt;
            return columns;
        }
        //Row Edit Event handler
        public inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row) as any;
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.BomRate || field === fld.Markup) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }

            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }
            var exchamgerate = (this.parentDialog as any).ExchangeRate == undefined ? 1 : (this.parentDialog as any).ExchangeRate;
            // *** Update Weight, Amount etc on Pieces Change***

             let _saveamountzerovalue: boolean = q.ToBool(TabAurous.GetConfigValue(1046));
            let minvalue = 0;
            if (_saveamountzerovalue)
                minvalue = -1;
            if (field === fld.BomRate && value > minvalue) {
                this.coef = (this.parentDialog as any).Coef;
                if (this.coef == null) {
                    if (item.CalcOnId == 3) {
                        item.BomAmount = value * item.Pieces;
                    } else if (item.CalcOnId == 4 || item.CalcOnId == 5) {

                        if (item.ItemTypeId == 104) {
                            var UseKaratWiseRate = q.ToBool(TabAurous.GetConfigValue(1014)); 
                            if (UseKaratWiseRate)
                                item.BomAmount = value * item.Weight || 0;
                            else
                                item.BomAmount = value * item.Weight * item.Purity || 0;
                        }
                        else {
                            item.BomAmount = value * item.Weight || 0;
                        }
                    }
                    item.CCBomAmount = item.BomAmount * exchamgerate;
                    item[field] = value;
                }
                else {
                    value = value * this.coef;
                    if (item.CalcOnId == 3) {                        
                        item.BomAmount = value * item.Pieces;
                    } else if (item.CalcOnId == 4 || item.CalcOnId == 5) {

                        if (item.ItemTypeId == 104) {
                            var UseKaratWiseRate = q.ToBool(TabAurous.GetConfigValue(1014));
                            if (UseKaratWiseRate)
                                item.BomAmount = value * item.Weight || 0;
                            else
                                item.BomAmount = value * item.Weight * item.Purity || 0;
                        }
                        else {
                            item.BomAmount = value * item.Weight || 0;
                        }
                    }
                    item.CCBomAmount = item.BomAmount * exchamgerate;
                    item[field] = value;
                }
            }

            if (field === fld.Markup && value > 0) {
                if (item.CalcOnId == 3) {
                    item.BomAmount = (value * item.BomRate)* item.Pieces;
                } else if (item.CalcOnId == 4 || item.CalcOnId == 5) {

                    if (item.ItemTypeId == 104) {
                        var UseKaratWiseRate = q.ToBool(TabAurous.GetConfigValue(1014));
                        if (UseKaratWiseRate)
                            item.BomAmount = (value * item.BomRate) * item.Weight || 0;
                        else
                            item.BomAmount = (value * item.BomRate) * item.Weight * item.Purity || 0;
                    }
                    else {
                        item.BomAmount = (value * item.BomRate) * item.Weight || 0;
                    }
                }
                item[field] = value;
            }

            this.view.updateItem(id, item);
            (this.parentDialog as any).CalculateTotals();
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion

        public getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        setMasterValues() {
            this.RateListId = (this.parentDialog as any).RateListId;
            this.LaborListId = (this.parentDialog as any).LaborMarkup;
            this.StoneMarkup = (this.parentDialog as any).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as any).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as any).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as any).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as any).ExchangeRate;
            this.TransDate = (this.parentDialog as any).TransDate;
            this.PartyId = (this.parentDialog as any).PartyId;
            this.MarkUpPolicyId = (this.parentDialog as any).MarkUpPolicyId;
            this.coef = (this.parentDialog as any).coef;
        }
    }
}